export class Document {
  id?: number;
  filename?: string;
  size?: number;
  title?: string;
  uniqid?: string;
  label?: number;
  monitor?: boolean;
  tag?: string;
  availableSince?: Date;
  company?: any;
  group?: any;
  uploadedBy?: string;
  companiesUniqids?: string[];
  deleted?: boolean;
  isNew?: boolean;
  watchedFiles?: boolean;
  nbOfWatchers?: number;
  notification?: boolean;
}
